angular.module('satv.mediastats')
.controller('SubjectListCtrl', ['$scope', 'statLoader', '$state', '$window', 'config', 'Auth', '$httpParamSerializer', function($scope, statLoader, $state, $window, config, Auth, $httpParamSerializer) {
    $scope.statLoader = statLoader.getFirstPage();

    var searchConfig = {};
    searchConfig = angular.copy($state.params);
    $scope.searchConfig = searchConfig;

    $scope.search = function(searchConfig) {
        $state.go($state.current.name, searchConfig);
    };

    $scope.downloadHistory = function(searchConfig) {
       var params;
       var user;

        Auth.getAccess()
            .then(function(a, user){
            	user = a.loggedInAs.replace(/ /g, '_');
            	console.log(params);

            	params = angular.copy(searchConfig);
                params._format = 'csv';
                params.pageSize = 0;
                params.type = $state.current.name == 'myMusic.auditionHistory' ? 'audition' : 'download';
                params.user = 'session';
                params.filename = params.type + 's_' + user + '_' + '.csv';

                var url = config.apiUri + '/media/stats?' + $httpParamSerializer(params);
                $window.location.href = url;
             });
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/controllers/SubjectListCtrl.js